import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../../utils/Methods";
import { IDS } from "../../../../../utils/IDS";

export const EventRegistrations = createAsyncThunk(
  "common/masters/EventRegistrations",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.EventReg}?name=${filter?.name || ""}&email=${filter?.email || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE
        }&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""
        }&reg_id=${filter?.reg_id || ""}&event_id=${filter?.event_id || ""}`
      );
      if (res?.data?.success) {
        return res.data;
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
//  Get All
export const GetAll = createAsyncThunk(
  "masters/event/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Event}?term=${filter?.name || ""}` +
        `&event_category_id=${filter?.event_category_id || ""}` +
        `&event_type_id=${filter?.event_type_id || ""}` +
        `&start_date=${filter?.start_date || ""}` +
        `&end_date=${filter?.end_date || ""}` +
        `&page=${filter?.page || IDS.PAGE}` +
        `&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Get Single
export const GetSingle = createAsyncThunk(
  "masters/event/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Event}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetEventFormStatus = createAsyncThunk(
  "masters/event/get-form-status",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Event}/form-status`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//  Create (Add)
export const UpdateEventFormStatus = createAsyncThunk(
  "masters/event/update-form-status",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Event}/form-status`, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res); // The new country object
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const Create = createAsyncThunk(
  "masters/event/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Event, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res); // The new country object
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//  Update
export const Update = createAsyncThunk(
  "masters/event/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.Event}/${id}`, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//  Delete
export const Delete = createAsyncThunk(
  "masters/event/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Masters.Event}/${id}`);
      return id; // Return the id of the deleted country
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//  Status
export const Status = createAsyncThunk(
  "masters/event/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Event}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const HomeStatus = createAsyncThunk(
  "masters/event/home-status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Event}/home/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const toggleComplteStatus = createAsyncThunk(
  "masters/event/toggleComplteStatus",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Event}/complete/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UploadExcelForAllote = createAsyncThunk(
  "masters/event/UploadExcelForAllote",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Event}/event-room-allot`, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetAllActive = createAsyncThunk(
  "masters/event/get-all-active",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Event}/all-active-events?term=${filter?.name || ""}` +
        `&event_category_id=${filter?.event_category_id || ""}` +
        `&event_type_id=${filter?.event_type_id || ""}` +
        `&startDate=${filter?.startDate || ""}` +
        `&endDate=${filter?.endDate || ""}` +
        `&page=${filter?.page || IDS.PAGE}` +
        `&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllCompleted = createAsyncThunk(
  "masters/event/get-all-completed",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Event}/all-completed-events?term=${filter?.name || ""
        }` +
        `&event_category_id=${filter?.event_category_id || ""}` +
        `&event_type_id=${filter?.event_type_id || ""}` +
        `&startDate=${filter?.start_date || ""}` +
        `&endDate=${filter?.end_date || ""}` +
        `&page=${filter?.page || IDS.PAGE}` +
        `&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllUpcoming = createAsyncThunk(
  "masters/event/get-all-upcoming",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Event}/all-upcoming-events?term=${filter?.name || ""}` +
        `&event_category_id=${filter?.event_category_id || ""}` +
        `&event_type_id=${filter?.event_type_id || ""}` +
        `&startDate=${filter?.start_date || ""}` +
        `&endDate=${filter?.end_date || ""}` +
        `&page=${filter?.page || IDS.PAGE}` +
        `&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const SendEventNotifications = createAsyncThunk(
  "masters/event/SendEventNotifications",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Event}/send-notification`, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const Slice = createSlice({
  name: "event",
  initialState: {
    data: [],
    active_events: [],
    upcoming_events: [],
    completed_events: [],
    form_status: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(EventRegistrations.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(EventRegistrations.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data || [];
        state.current_page = action.payload?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.per_page || IDS.PERPAGE;
        state.total = action.payload?.total || IDS.TOTAL;
      })
      .addCase(EventRegistrations.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (country) => country.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (country) => country.id !== action.payload.id
        ); // Remove the country with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (country) => country.id !== action.payload.id
        ); // Remove the country with the deleted id
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetEventFormStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetEventFormStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.form_status = action.payload?.data || [];
      })
      .addCase(GetEventFormStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllActive.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllActive.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.active_events = action.payload?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllActive.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllUpcoming.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllUpcoming.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.upcoming_events = action.payload?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllUpcoming.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllCompleted.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllCompleted.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.completed_events = action.payload?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllCompleted.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
